import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';

export const GET_SUBSCRIPTIONTYPES = 'GET_SUBSCRIPTIONTYPES';
export const SELECT_SUBSCRIPTIONTYPE = 'SELECT_SUBSCRIPTIONTYPE';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";


export function fetchSubscriptionTypes() {
    return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageMagazineSubscriptionType/GetMagazineSubscriptionTypes`)
			.then((response) => {
				dispatch({
					type: GET_SUBSCRIPTIONTYPES,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function selectSubscriptionType(selectedSubscriptionTypeObject) {
    return function (dispatch) {
        dispatch({
            type: SELECT_SUBSCRIPTIONTYPE,
            selectedSubscriptionType: selectedSubscriptionTypeObject
        })
    }
}